import { maybe } from "shared/maybe";
/**
 * Converts a string to an ID or undefined on failure.
 * @param string A string.
 * @returns An ID or undefined.
 */
function stringToIdOrUndefined(string, parseId) {
    try {
        return parseId(string);
    }
    catch (e) {
        return;
    }
}
export function sanitizeToStrings(value) {
    if (Array.isArray(value)) {
        return value.map(sanitizeToString).filter((_) => _ !== undefined);
    }
    const string = sanitizeToString(value);
    if (string === undefined) {
        return [];
    }
    return [string];
}
export function sanitizeToString(value) {
    try {
        if (Array.isArray(value)) {
            return value.map(sanitizeToString).at(0);
        }
        else if (typeof value === "object") {
            return JSON.stringify(value);
        }
        else if (typeof value === "string" && value === "") {
            return;
        }
        return String(value);
    }
    catch (e) {
        return;
    }
}
export function verifyString(input) {
    if (typeof input === "string") {
        return input;
    }
}
export function sanitizeToBoolean(input) {
    return !!input;
}
export function verifyBoolean(input) {
    if (typeof input === "boolean") {
        return input;
    }
}
export function sanitizeToNumber(input) {
    const number = maybe(sanitizeToString(input), parseFloat);
    if (Number.isNaN(number)) {
        return;
    }
    return number;
}
export function verifyNumber(input) {
    if (typeof input === "number") {
        return input;
    }
}
export function sanitizeToIds(input, parseId) {
    return sanitizeToStrings(input).flatMap(string => stringToIdOrUndefined(string, parseId)).filter((_) => _ !== undefined);
}
export function verifyIds(input, isId) {
    if (Array.isArray(input)) {
        return input.filter(isId);
        //return input.flatMap(element => ArrayBuffer.isView(element) ? [element] : []) as unknown as readonly ID[]
    }
}
export function sanitizeToId(input, parseId) {
    return sanitizeToStrings(input).flatMap(string => stringToIdOrUndefined(string, parseId)).filter((_) => _ !== undefined).at(0);
}
export function verifyId(input, isId) {
    if (isId(input)) {
        return input;
    }
}
export function sanitizeField(type, input, parseId) {
    if (input === null) {
        return;
    }
    else if (type === "BOOLEAN") {
        return sanitizeToBoolean(input);
    }
    else if (type === "NUMBER") {
        return sanitizeToNumber(input);
    }
    else if (type === "FILES" || type === "PHOTOS") {
        return sanitizeToIds(input, parseId);
    }
    else if (type === "FILE" || type === "PHOTO") {
        return sanitizeToId(input, parseId);
    }
    else {
        return sanitizeToString(input);
    }
}
export function sanitizeFieldToPrint(type, input) {
    if (input === null) {
        return null;
    }
    else if (type === "BOOLEAN") {
        return sanitizeToBoolean(input);
    }
    else if (type === "NUMBER") {
        return sanitizeToNumber(input) ?? null;
    }
    else if (type === "FILES" || type === "PHOTOS") {
        return sanitizeToStrings(input);
    }
    else if (type === "FILE" || type === "PHOTO") {
        return sanitizeToString(input) ?? null;
    }
    else {
        return sanitizeToString(input) ?? null;
    }
}
